export default __webpack_public_path__ + "static/media/PhoneVideo.840cbc94.mp4";